import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {
  FormGroup,
  FieldGroup,
  FieldStatus,
  Select,
  MenuItem,
  Input
} from 'rambler-ui'
import {createDeferHandler} from '@rambler-id/react'
import {ios, android} from '@rambler-id/browser'
import styles from './styles.css'

const createISODateString = (date, type) => {
  const dateISO = date.toISOString()
  const dateString = dateISO.substring(0, dateISO.indexOf('T'))

  return type === 'month' ? dateString.replace(/-\d+$/, '') : dateString
}

const days = [...Array(32)].map((_, i) => i)

const months = [
  0,
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь'
]

export default class BirthdayField extends PureComponent {
  static propTypes = {
    inline: PropTypes.bool,
    label: PropTypes.string,
    autoFocus: PropTypes.bool,
    clearable: PropTypes.bool,
    size: PropTypes.string,
    input: PropTypes.object,
    meta: PropTypes.object,
    cerberId: PropTypes.func,
    disabled: PropTypes.bool,
    type: PropTypes.string,
    minYear: PropTypes.number,
    maxYear: PropTypes.number
  }

  static defaultProps = {
    type: 'date',
    minYear: 1910,
    maxYear: new Date().getFullYear() - 5
  }

  get minDateString() {
    return createISODateString(new Date(this.props.minYear, 0, 1))
  }

  get maxDateString() {
    return createISODateString(new Date(this.props.maxYear + 1, 0, 1))
  }

  get years() {
    const {minYear, maxYear} = this.props

    return [0, ...Array(maxYear - minYear + 1)].map((value, i) =>
      i ? maxYear - i + 1 : i
    )
  }

  get error() {
    const {meta} = this.props

    return meta.touched && meta.error
  }

  get status() {
    return this.error ? 'error' : null
  }

  blur = createDeferHandler((event) => {
    const {input} = this.props
    const {relatedTarget} = event
    let parent

    try {
      parent =
        relatedTarget &&
        relatedTarget.parentNode.parentNode.parentNode.parentNode.parentNode
    } catch (error) {} // eslint-disable-line no-empty

    if (!parent || !parent.classList.contains(styles.birthday)) {
      input.onBlur()
    }
  })

  onDateInputChange = (event, value) => {
    const {input, type} = this.props
    const date = value
      .split('-')
      .map((str) => +str)
      .reverse()

    if (type === 'month' && date.length < 3) {
      date.unshift(1)
    }

    input.onChange(date)
  }

  renderNativeDatePicker = () => {
    const {input, autoFocus, type, size, disabled} = this.props
    const [day = +(type === 'month'), month = 0, year = 0] = input.value

    const dateValue =
      year === 0
        ? ''
        : createISODateString(new Date(Date.UTC(year, month - 1, day)), type)

    return (
      <FieldGroup
        className={styles.birthday}
        showDivider
        size={size}
        disabled={disabled}
        status={this.status}
      >
        <Input
          {...input}
          type={type}
          className="-metrika-nokeys"
          id={input.name}
          min={this.minDateString}
          max={this.maxDateString}
          value={dateValue}
          autoFocus={autoFocus}
          onChange={this.onDateInputChange}
          onBlur={this.blur}
        />
      </FieldGroup>
    )
  }

  renderDatePicker = () => {
    const {
      autoFocus,
      clearable,
      input,
      cerberId = () => undefined,
      size,
      type,
      disabled
    } = this.props
    const [day = +(type === 'month'), month = 0, year = 0] = input.value

    return (
      <FieldGroup
        className={
          styles.birthday + ' ' + (type === 'month' ? styles.month : '')
        }
        showDivider
        size={size}
        disabled={disabled}
        status={this.status}
      >
        {type === 'date' && (
          <Select
            {...input}
            className="-metrika-nokeys"
            id={input.name}
            placeholder="День"
            tabIndex="0"
            autoFocus={autoFocus}
            inputValueRenderer={(value) => value || ''}
            value={day}
            onChange={(day) => input.onChange([day, month, year])}
            onBlur={this.blur}
            data-cerber-id={cerberId('day')}
          >
            {days
              .filter((value) => clearable || !!value)
              .map((value) => (
                <MenuItem key={value} value={value}>
                  {value || 'День'}
                </MenuItem>
              ))}
          </Select>
        )}
        <Select
          {...input}
          className="-metrika-nokeys"
          placeholder="Месяц"
          tabIndex="0"
          inputValueRenderer={(value) => (value ? months[value] : '')}
          value={month}
          onChange={(month) => input.onChange([day, month, year])}
          onBlur={this.blur}
          data-cerber-id={cerberId('month')}
        >
          {months
            .filter((value) => clearable || !!value)
            .map((value, i) => (
              <MenuItem key={i} value={i + (clearable ? 0 : +1)}>
                {value || 'Месяц'}
              </MenuItem>
            ))}
        </Select>
        <Select
          {...input}
          className="-metrika-nokeys"
          placeholder="Год"
          tabIndex="0"
          inputValueRenderer={(value) => value || ''}
          value={year}
          onChange={(year) => input.onChange([day, month, year])}
          onBlur={this.blur}
          data-cerber-id={cerberId('year')}
        >
          {this.years
            .filter((value) => clearable || !!value)
            .map((value) => (
              <MenuItem key={value} value={value}>
                {value || 'Год'}
              </MenuItem>
            ))}
        </Select>
      </FieldGroup>
    )
  }

  render() {
    const {inline, label, input} = this.props
    const isNativeInputAllowed = ios || android

    return (
      <FormGroup inline={inline} label={label} fieldId={input.name}>
        <FieldStatus type={this.status} message={this.error}>
          {isNativeInputAllowed
            ? this.renderNativeDatePicker()
            : this.renderDatePicker()}
        </FieldStatus>
      </FormGroup>
    )
  }
}
